import { BowlCollection, isRole, isTenant, roles } from '@websolutespa/payload-plugin-bowl';
import { options } from '../options';

export const LlmRule: BowlCollection = {
  type: 'withCollection',
  slug: options.slug.llmRule,
  admin: {
    group: options.group.llm,
    defaultColumns: ['llmApp', 'description'],
    listSearchableFields: ['llmApp', 'description'],
    components: {
      beforeListTable: [
        '@websolutespa/payload-plugin-bowl-llm/client#BtnGenerateRulesVectorDb'
      ]
    },
  },
  access: {
    create: (args) => isRole(roles.Admin, options.roles.LlmEditor, options.roles.LlmContributor)(args),
    read: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmRule)(args),
    update: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmRule)(args),
    delete: (args) => isRole(roles.Admin)(args) || isTenant(options.slug.llmRule)(args),
  },
  fields: [
    {
      type: 'withIsActive',
    },
    {
      name: 'llmApp',
      type: 'relationship',
      relationTo: options.slug.llmApp,
    },
    {
      name: 'description',
      type: 'textarea',
    },
  ],
};

